import { chatAPI } from './api'

class FAQService {
  constructor() {
    this.cache = {} // Cache pro Sprache: { de: [...], en: [...], ... }
    this.lastFetch = {} // Last fetch pro Sprache
    this.cacheDuration = 5 * 60 * 1000 // 5 Minuten Cache
  }

  async getFAQs(lang = 'de') {
    // Validiere Sprache
    const validLanguages = ['de', 'en', 'fr', 'it', 'es', 'pt', 'pl'];
    const requestLang = validLanguages.includes(lang) ? lang : 'de';
    
    // Cache prüfen für diese spezifische Sprache
    const now = Date.now();
    if (this.cache[requestLang] && 
        this.lastFetch[requestLang] && 
        now - this.lastFetch[requestLang] < this.cacheDuration) {
      //console.log(`📦 Verwende Cache für ${requestLang} (${this.cache[requestLang].length} Fragen)`)
      return this.cache[requestLang]
    }

    try {
      //console.log(`🔄 Lade FAQs für Sprache: ${requestLang}`)
      
      // API mit korrekter Sprache aufrufen
      const response = await chatAPI.getFAQsFromCockpit(requestLang)
      
      if (response && response.entries) {
        // Fragen extrahieren und bereinigen
        const questions = response.entries
          .map(entry => entry.title_question)
          .filter(question => question && question.trim())
          .slice(0, 50) // Begrenze auf 50 Fragen für Performance
        
        // Cache für diese Sprache aktualisieren
        this.cache[requestLang] = questions
        this.lastFetch[requestLang] = now
        
        //console.log(`✅ ${questions.length} FAQs für ${requestLang} geladen`)
        return questions
      }
      
      return []
    } catch (error) {
      console.error(`❌ Fehler beim Laden der FAQs für ${requestLang}:`, error)
      // Fallback auf leere Liste
      return []
    }
  }

  // Cache für bestimmte Sprache zurücksetzen
  clearCache(lang = null) {
    if (lang) {
      delete this.cache[lang]
      delete this.lastFetch[lang]
    } else {
      this.cache = {}
      this.lastFetch = {}
    }
  }

  // Verfügbare Sprachen abrufen
  getAvailableLanguages() {
    return ['de', 'en', 'fr', 'it', 'es', 'pt', 'pl']
  }
}

export const faqService = new FAQService()